// @ts-nocheck

export type RoomGetWithTenantsOccupants = typeof RoomGetWithTenantsOccupants[keyof typeof RoomGetWithTenantsOccupants];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithTenantsOccupants = {
  true: 'true',
  false: 'false',
} as const;
